'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { localizePath } from '@/lib/i18n/routing'
import { useAppLocale } from './locale-provider'

/**
 * `next/link` that keeps the reader in their language: a marketing path
 * (`/pricing`) becomes the reader's (`/de/pricing`); product paths, other
 * origins and URL objects pass through unchanged.
 */
export function LocalizedLink({ href, ...props }: ComponentProps<typeof Link>) {
  const locale = useAppLocale()
  return (
    <Link
      href={
        typeof href === 'string' &&
        href.startsWith('/') &&
        !href.startsWith('//')
          ? localizePath(locale, href)
          : href
      }
      {...props}
    />
  )
}
